module.exports = __webpack_public_path__ + "public/img/logo_amikom.953c041f.png";